var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "holiday-search__autocomplete",
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      },
      [
        _c("div", { staticClass: "form-check search-filter-dropdown-select" }, [
          _c(
            "ul",
            { staticClass: "list-unstyled w-100" },
            _vm._l(_vm.items, function (item) {
              return _c(
                "li",
                {
                  key: item.value,
                  staticClass:
                    "filter-list__item holiday-search__autocomplete-btn",
                },
                [
                  _c(
                    "label",
                    { staticClass: "checkbox-label dropdown-list-item m-0" },
                    [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: item.selected,
                            expression: "item.selected",
                          },
                        ],
                        attrs: {
                          type: "checkbox",
                          name: _vm.name,
                          title: item.value,
                        },
                        domProps: {
                          value: item.value,
                          checked: Array.isArray(item.selected)
                            ? _vm._i(item.selected, item.value) > -1
                            : item.selected,
                        },
                        on: {
                          change: function ($event) {
                            var $$a = item.selected,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = item.value,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(item, "selected", $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    item,
                                    "selected",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(item, "selected", $$c)
                            }
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "filter-list__label m-0",
                          class: { "fw-bold": item.selected },
                          attrs: { title: item.label },
                        },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(item.label) +
                              "\n            "
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn holiday-search__btn",
            attrs: {
              type: "button",
              "aria-label": "Apply selected holiday options",
              title: "Apply selected holiday options",
            },
            on: { click: _vm.applySelection },
          },
          [_vm._v("\n      Done\n    ")]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }